import React, { useContext } from 'react';
import * as NumberFormatHelper from '../../../helpers/NumberFormatHelper';
import styles from './styles.module.css';
import PageHeader from '../../utils/PageHeader/PageHeader';
import NavBar from '../../utils/NavBar/NavBar';
import { Grid } from '@mui/material';
import { ShopContext } from '../../../contexts/ShopContext';
import { ROUTES, PRODUCT_TYPES } from '../../../const';
import { CartContext } from '../../../contexts/CartContext';

import CustomButton from '../../utils/CustomerComponents/CustomButton';
import ProductView from '../../utils/ProductView/ProductView';
import { useHistory } from 'react-router-dom';
import EmptyCartIcon from '../../icons/emptyCart.png';
import ProductQtyUpdateSec from '../../utils/ProductView/ProductQtyUpdateSec';

function Cart() {
  const history = useHistory();
  const { shop } = useContext(ShopContext);
  const { cart } = useContext(CartContext);

  const handleMoveCusomerDetailsPage = () => {
    history.push(ROUTES.CUSTOMER_DETAILS.replace(':shopId', shop?.shopId));
  };

  const isCartEmpty = !cart?.products || Object.keys(cart.products).length === 0;

  return (
    <>
      <PageHeader title="My Cart" />
      <div className={styles.container}>
        <Grid container height={'100%'}>
          {isCartEmpty ? (
            <Grid
              item
              xs={12}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              pt={10}
            >
              <img
                src={EmptyCartIcon}
                alt="Empty Cart"
                style={{ width: '150px', height: '150px', marginBottom: '20px' }}
              />
              <span className={styles.emptyCartText}>Cart is empty</span>
            </Grid>
          ) : (
            <>
              <Grid item container spacing={1} xs={12} pt={1} className={styles.cartContainer}>
                {Object.values(cart.products).map(({ product, quantity }) => {
                  const cardKey = product?.cartKey || `${product.id}`;

                  const isSoldOut = product.type !== PRODUCT_TYPES.SERVICE && product.stock <= 0;
                  const isOnHold = product.type !== PRODUCT_TYPES.SERVICE && product.stock > 0 && product.stock - product.stock_on_hold <= 0;
                  const disable = isSoldOut || isOnHold;

                  return (
                    <ProductView
                      key={cardKey}
                      product={product}
                      CardEndView={() => (
                        <ProductQtyUpdateSec
                          product={product}
                          disableAddButton={disable}
                          isCartPage={true}
                          quantityInCart={quantity}
                        />
                      )}
                      gridSize={{ xs: 12, sm: 6, md: 3 }}
                      compactView={true}
                    />
                  );
                })}
              </Grid>
              <Grid item xs={12} pt={2}>
                <div className={styles.divider}></div>
              </Grid>
              <Grid item xs={12} pt={2}>
                <span className={styles.header}>Payment Summary</span>
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pt={2}>
                <span className={styles.text1}>Price</span>
                <span className={styles.text2}>
                  {NumberFormatHelper.amountFormat(cart?.summary?.subTotal || 0, shop)}
                </span>
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pt={1}>
                <span className={styles.text1}>Tax</span>
                <span className={styles.text2}>
                  {NumberFormatHelper.amountFormat(cart?.summary?.tax || 0, shop)}
                </span>
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" pb={1}>
                <span className={styles.text1}>Discount</span>
                <span className={styles.text2}>
                  {NumberFormatHelper.amountFormat(cart?.summary?.discount || 0, shop)}
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                pt={1}
                className={styles.divTopBorder}
              >
                <span className={styles.text1}>Total Payment</span>
                <span className={styles.text2}>
                  {NumberFormatHelper.amountFormat(cart?.summary?.payable || 0, shop)}
                </span>
              </Grid>
              <Grid item xs={12} pt={3}>
                <CustomButton
                  fullWidth
                  onClick={handleMoveCusomerDetailsPage}
                  disabled={isCartEmpty}
                  bgcolor="rgba(248, 151, 34, 1)"
                  hoverBg="rgba(248, 151, 34, 0.8)"
                >
                  Order now
                </CustomButton>
              </Grid>
            </>
          )}
        </Grid>
        <NavBar />
      </div>
    </>
  );
}

export default Cart;
